import { Link, useLocation } from 'react-router-dom'
import { 
  LayoutDashboard, 
  Calendar, 
  Heart, 
  Users, 
  Settings,
  Gift,
  CreditCard,
  Image as ImageIcon,
  FileText,
  Video,
  MessageCircle,
  X
} from 'lucide-react'

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation()
  
  const navigation = [
    { name: 'Dashboard', href: '/', icon: LayoutDashboard },
    { name: 'Bookings', href: '/bookings', icon: Calendar },
    { name: 'Services', href: '/services', icon: Heart },
    { name: 'Gift Cards', href: '/gift-cards', icon: Gift },
    { name: 'Manual Payments', href: '/manual-payments', icon: CreditCard },
    { name: 'Customers', href: '/customers', icon: Users },
    { name: 'Gallery', href: '/gallery', icon: ImageIcon },
    { name: 'Blog', href: '/blog', icon: FileText },
    { name: 'Help Center', href: '/help-center', icon: Video },
    { name: 'Messaging', href: '/messaging', icon: MessageCircle },
    { name: 'Settings', href: '/settings', icon: Settings },
  ]

  return (
    <div className={`sidebar fixed inset-y-0 left-0 z-50 w-64 bg-slate-950/90 border-r border-purple-800/60 shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
      {/* Fixed Header */}
      <div className="flex-shrink-0">
        {/* Close button */}
        <div className="flex justify-end p-4">
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-white hover:bg-slate-800/80 rounded-lg transition-colors duration-200"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 pb-4">
          <Link to="/" className="flex items-center space-x-2" onClick={onClose}>
            <img 
              src="/media/images/lumoralogo.png" 
              alt="Spa~Radise Luxe Logo" 
              className="w-12 h-12 object-contain rounded-full border border-purple-200 shadow-sm"
            />
            <span className="text-xl font-semibold text-white">Spa~Radise Luxe Admin</span>
          </Link>
        </div>
      </div>
      
      {/* Scrollable Navigation */}
      <nav className="flex-1 overflow-y-auto px-4 pb-4">
        <ul className="space-y-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  onClick={onClose}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors duration-200 ${
                    isActive 
                      ? 'bg-primary-500 text-white' 
                      : 'text-gray-300 hover:bg-slate-800/80 hover:text-white'
                  }`}
                >
                  <item.icon className="w-5 h-5" />
                  <span className="font-medium">{item.name}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>
    </div>
  )
}

export default Sidebar
